import React, { Component } from 'react';
import Pdf from './ManualdoUsuário.pdf';
import { Button } from "react-bootstrap";

export class Manual extends Component {
  render() {
    return (
        <div className = "App">
            <a href={'https://nbra-pr-lpp-usea-001-app.azurewebsites.net/standard/1207-TRAININGMATERIAL-2021-65'} target = "_blank">
            <Button variant={'light'} size={'sm'}><div>Abrir</div>Manual</Button>
          </a>
        </div>
    );
  }
}

export default Manual;